<template>
  <SkeletonBlock :is-active="isSkeletonActive">
    <template #skeleton>
      <template
        v-for="i in cardsCount"
        :key="i"
      >
        <ExpCardSkeleton :is-animated="isAnimated" />
        <SkeletonItem
          v-if="isShowBanner(i)"
          width="100%"
          :height="456"
        />
      </template>
    </template>
    <slot />
  </SkeletonBlock>
</template>

<script setup lang="ts">
  // Widgets

  // Features

  // Entities

  // Shared
  import { useExcursionListingSkeleton } from '@/shared/composables/excursion/useExcursionDelayedListingSkeleton.ts';

  // External and shared packages
  import { SkeletonBlock, SkeletonItem } from '@experience/core-skeleton-lib';
  import { ExpCardSkeleton } from '@experience/exp-card';
  import { computed, watch, ref } from 'vue';

  const CARDS_COUNT_INITIAL = 12;
  const CARDS_COUNT_FULL = 49;

  const route = useRoute();
  const isPageLoaded = ref(sessionStorage.getItem('skeleton-lib:page-loaded') === 'true');

  // Update flag when route changes
  watch(
    () => route.path,
    () => {
      isPageLoaded.value = sessionStorage.getItem('skeleton-lib:page-loaded') === 'true';
    },
  );

  const isAnimated = computed(() => isPageLoaded.value);

  const { isSkeletonActive } = useExcursionListingSkeleton();

  const cardsCount = computed(() => (isPageLoaded.value ? CARDS_COUNT_FULL : CARDS_COUNT_INITIAL));

  const isShowBanner = (index: number) => {
    const bannerIndices = [2, 5, 12, 15, 22];

    return bannerIndices.includes(index);
  };
</script>

<style scoped lang="scss">
  @use '@experience/shared/dist/assets/adaptivity' as adaptivity;
</style>
